// extracted by mini-css-extract-plugin
module.exports = {"center":"about-module--center--3hF8M"};